export default __webpack_public_path__ + "static/media/Filipe Bregantim.933fcd39.png";